import { z } from 'zod';
import {
  Attribution,
  Cid,
  SessionKey,
  SiteId,
  TenantId,
  VideoCtaAttribution,
  VisitorKey,
} from './common';

export const LeadRequest = z.object({
  tenant_id: TenantId,
  site_id: SiteId,
  landing_page_id: z.string().regex(/^lp_[a-zA-Z0-9_-]{1,61}$/),
  visitor_id: VisitorKey,
  session_id: SessionKey,
  cid: Cid.nullable().optional(),
  form_id: z.string().min(1).max(128),
  source_url: z.string().url().max(2048).nullable().optional(),
  detected_title: z.string().max(255).nullable().optional(),
  page_heading: z.string().max(255).nullable().optional(),
  field_names: z.array(z.string().max(64)).max(50).nullable().optional(),

  form_data: z
    .object({
      name: z.string().max(255).optional(),
      company_name: z.string().max(255).optional(),
      email: z.string().email().max(320).optional(),
      phone_number: z.string().max(64).optional(),
      inquiry_type: z.string().max(255).optional(),
      message: z.string().max(10_000).optional(),
    })
    .passthrough(),

  page_location: z.string().url().max(2048).optional(),
  referrer: z.string().max(2048).nullable().optional(),
  attribution: Attribution.optional(),

  video_summary: z
    .object({
      video_id: z.string().min(1).max(128),
      video_title: z.string().min(1).max(255),
      video_url: z.string().max(2048).nullable().optional(),
      video_started: z.boolean(),
      video_max_percent: z.number().int().min(0).max(100),
      video_completed: z.boolean(),
      video_last_position: z.number().min(0).nullable().optional(),
      video_duration: z.number().min(0).nullable().optional(),
      video_cta_clicked: z.boolean(),
      video_cta_id: z.string().max(128).nullable().optional(),
      video_cta_name: z.string().max(255).nullable().optional(),
      video_cta_attribution: VideoCtaAttribution.optional(),
    })
    .nullable()
    .optional(),

  submitted_at: z.string().datetime(),
});

export type LeadRequest = z.infer<typeof LeadRequest>;
